<template>
  <div>
    <a-list itemLayout="horizontal" :dataSource="listData">
      <a-list-item slot="renderItem" slot-scope="item, index" :key="index">
        <a-list-item-meta>
          <a slot="title">{{ item.title }}</a>
          <span slot="description">
            <span class="security-list-description">{{ item.description }}</span>
            <span v-if="item.value">:</span>
            <span class="security-list-value">{{ item.value }}</span>
          </span>
        </a-list-item-meta>
        <template v-if="item.actions">
          <a slot="actions" @click="item.actions.callback">{{ item.actions.title }}</a>
        </template>
      </a-list-item>
    </a-list>
    <user-password ref="userPassword"></user-password>
    <user-phone ref="userInfo" v-on:close="close"></user-phone>
  </div>
</template>

<script>
import UserPassword from './components/UserPassword'
import UserPhone from './components/UserPhone'

import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  components: {
    UserPassword,
    UserPhone
  },
  computed: {
    // listData() {
    //   return 
    // }
  },
  data() {
    return {
      listData:[
        {
          title: this.$t('account.settings.security.password'),
          actions: {
            title: this.$t('account.settings.security.modify'),
            callback: () => {
              this.updatePassword()
            }
          }
        },
        {
          title: this.$t('account.settings.security.phone'),
          description: this.$t('account.settings.security.phone-description'),
          value: '138****8293',
          actions: {
            title: this.$t('account.settings.security.modify'),
            callback: () => {
              this.updateUserInfo()
            }
          }
        },
        {
          title: this.$t('account.settings.security.email'),
          description: this.$t('account.settings.security.email-description'),
          value: 'ant***sign.com',
          actions: {
            title: this.$t('account.settings.security.modify'),
            callback: () => {
              this.updateUserInfo()
            }
          }
        }
        // { title: this.$t('account.settings.security.mfa'), description: this.$t('account.settings.security.mfa-description'), value: '', actions: { title: this.$t('account.settings.security.bind'), callback: () => { this.$message.info('This is a normal message') } } }
      ]
    }
  },
  methods: {
    ...mapGetters(['nickname', 'avatar', 'userInfo']),
    close() {
      this.getList()
    },
    getList() {
      let obj = this.userInfo()
      console.log('2', obj)
      this.listData[1].value = obj.phone
      this.listData[2].value = obj.email

      this.$set(this.listData, 1, this.listData[1])
      this.$set(this.listData, 2, this.listData[2])
      console.log('2', this.listData)
    },
    updatePassword() {
      this.$refs.userPassword.show()
    },
    updateUserInfo() {
      let obj = this.userInfo()
      this.$refs.userInfo.show(obj)
    }
  },
  created() {
    this.getList()
  }
}
</script>

<style scoped>
</style>
